import { Component, Inject, LOCALE_ID, OnDestroy, ViewChild, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import { FourDService } from '4d-mapper';
import { AppService} from '../app.service';
import { Observable, of } from 'rxjs';
import { flatMap } from 'rxjs/operators';
import { FormControl, Validators } from '@angular/forms';
import { BaseComponent } from '../BaseComponent';
import { Router } from '@angular/router';
import { LinkURLDirective } from 'vasat-ng';
import { AccessGroup } from 'vasat';
import { TranslateService } from '@ngx-translate/core';
import { XsApplicationEventsService } from '../../xs/services/events/application-events.service';

@Component({
  selector: 'setup-dialog',
  templateUrl: './setup-dialog.html'
})

export class SetupDialog extends BaseComponent implements OnDestroy, OnInit {

  selectedIndex: number = 0;
  loading:boolean
  networkInterfaces:any
  selectedInterface:any

  addressControl = new FormControl('', [Validators.required]);
  netmaskControl = new FormControl('', [Validators.required]);
  gatewayControl = new FormControl('', [Validators.required]);

  @ViewChild(LinkURLDirective,{static:false}) imageDirective

  invite: {email:string,group:AccessGroup} = {email:null,group:null}
  groups: AccessGroup[] = []

  constructor(public router: Router, public snackBar: MatSnackBar, public dialogRef: MatDialogRef<SetupDialog>, @Inject(MAT_DIALOG_DATA) public data: any, 
  public fourD: FourDService, public service: AppService, @Inject(LOCALE_ID) private locale: string, public dialog: MatDialog, applicationEvents:XsApplicationEventsService) {
    super(router, snackBar, dialog)
  }



  ngOnDestroy(): void {

  }

  ngOnInit() {
    // Check network details
    this.checkNetwork()
    // Get user access groups
    this.fourD.activeTeam.accountGroups.queryObservable().subscribe(res => this.groups = res.items)
  }

  uploadFile(event) {
    this.loading = true
    let fileList: FileList = event.target.files
    if(fileList.length > 0) {
        let file: File = fileList[0]
        fetch(this.fourD.V.config.host + "/api/Account/" + this.fourD.activeTeam.id + '/image.png',{
            method: 'POST',
            body: file,
            headers:{
                'Content-type':'application/binary',
                Authorization:'bearer ' + this.service.V.authToken()
            }
          }
        ).then(r => {
            this.loading = false
            // Reload the img src after file uplaoded to server
            this.imageDirective.updateLink()
        })

    }
    else{
        this.loading = false
    }
  }

  checkNetwork() {
    this.selectedInterface = null // reset
    this.loading = true

    this.service.V.api("/admin/network", "get").subscribe(
        res => {
          this.networkInterfaces = res
          // Try to selected the default interface to configure
          this.selectedInterface = res.find( ele => ( ele.name.toLowerCase().startsWith("e") && ele.ip4 ) )
          console.log("ENTER this.selectedInterface:",this.selectedInterface)
          this.loading = false
        }, err => {

          this.loading = false
        }
      )
  }

  setNetwork(netIf:any) {
    this.addressControl.setValue(netIf.ip4)
    this.netmaskControl.setValue("")
    this.gatewayControl.setValue("")
  }

  networkSetup(netIf:any) {
    let loginObs:Observable<any>

    let args = {
      name:netIf.name,
      address:this.addressControl.value,
      netmask:this.netmaskControl.value
    }

    if (this.gatewayControl.value) {
      args["gateway"] = this.gatewayControl.value
    }

    this.service.V.api("/admin/network", "post", args)
      .subscribe(
        res => {
          this.loading = false
          this.openSnackBarSuccess('GENERIC.SUCCESS')
          // Reset to check changes applied
          //this.checkNetwork()
        }, err => {
          this.loading = false
          this.openSnackBarError(err.message)
        }
      )

  }

  sendInvite() {
    let args = {email:this.invite.email}
    console.log("ENTER args: ",args)
    this.fourD.V.api('/app/Account/' + this.fourD.activeTeam.id + '/invite/' + this.invite.group.id, 'post', args)
          .subscribe(
            res1 => {
              this.openSnackBarSuccess('SETTINGS.INVITE_SENT')
            }, err => {
              if (err.status == 92002)
                this.openDialog('PLAN.QUOTA', 'PLAN.QUOTA_DESC_USER')
              else
                this.openSnackBarError('ERROR.VASAT', '', err)
            }
          )
  }

  nextStep() {
    if (this.selectedIndex != 3) {
      this.selectedIndex = this.selectedIndex + 1;
    }
    console.log(this.selectedIndex);
  }

  closeDialog(){
    this.dialogRef.close();
  }

}
